<template>
  <div class="tx-pnpform-form">
    <div class="page-wrapper -max-width-limited" v-if="view.viewName !== 'Success'">
      <div class="page__head">
        <span class="heading">Schritt {{view.counter}} von {{ view.maxCount }}</span>
      </div>
      <div class="page__main">
        <div class="view-wrapper">
          <transition name="fade">
            <Component
                :is="view.viewName"
                @sendRequest="sendSoap"
                @updateView="updateView($event)"/>
          </transition>

        </div>
        <div class="pagination-wrapper">
          <Pagination/>
        </div>
      </div>
    </div>
    <div class="page-wrapper -max-width-limited" v-else>
      <div class="page__main -centered">
        <div class="view-wrapper success-page">
          <span class="heading alpha -color-white">Wir haben Ihre Reklamation erhalten</span>
          <div class="content__content">
            <div class="content__col">
              <div class="content__image">
                <img src="./assets/post-it.png" alt="Post it">
              </div>
              <div class="content__headline">
                <span class="heading beta -color-white">Schritt 1</span>
              </div>
              <div class="content__text">
                <p class="-color-white">Vielen Dank für Ihre Reklamation. Diese ist erfolgreich bei uns eingegangen.</p>
              </div>
            </div>
            <div class="content__col">
              <div class="content__image">
                <img src="./assets/post-it.png" alt="Post it">
              </div>
              <div class="content__headline">
                <span class="heading beta -color-white">Schritt 2</span>
              </div>
              <div class="content__text">
                <p class="-color-white">Ein Support Mitarbeiter prüft Ihre Anfrage und wird sich bei Rückfragen gegebenenfalls mit Ihnen in Verbindung setzen.</p>
              </div>
            </div>
            <div class="content__col">
              <div class="content__image">
                <img src="./assets/post-it.png" alt="Post it">
              </div>
              <div class="content__headline">
                <span class="heading beta -color-white">Schritt 3</span>
              </div>
              <div class="content__text">
                <p class="-color-white">Wir leiten die entsprechenden Schritte zur Lösung Ihres Problems ein und informieren Ihren Zusteller.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { ref } from 'vue';

import LocationSelector from '@/components/LocationSelector.vue';
// import DeliverySelector from '@/components/DeliverySelector.vue';
import Autocomplete from '@/components/Autocomplete.vue';
import NameEntry from '@/views/NameEntry.vue';
import AddressEntry from '@/views/AddressEntry.vue';
import ContactDataEntry from '@/views/ContactDataEntry.vue';
import ReclamationEntry from '@/views/ReclamationEntry.vue';
import DeliveryEntry from '@/views/DeliveryEntry.vue';
import PrivacyEntry from '@/views/PrivacyEntry.vue';

import Pagination from '@/components/Pagination.vue';

import { useUserStore } from '@/stores/user';
import { useLocationStore } from '@/stores/location';
import { useViewStore } from '@/stores/view';
import axios from 'axios';
import { useReasonStore } from '@/stores/reason';
import { useDeliveryStore } from '@/stores/delivery';

export default {
  components: {
    Pagination,
    LocationSelector,
    Autocomplete,
    NameEntry,
    AddressEntry,
    ContactDataEntry,
    ReclamationEntry,
    DeliveryEntry,
    PrivacyEntry,
  },
  methods: {
    sendSoap() {
      const data = {
        companyCode: this.locations.userLocation.companyCode.toString(),
        number: this.locations.userLocation.number.toString(),
        productIdentifier: this.locations.userLocation.productIdentifier.toString(),
        name: `${this.user.firstname} ${this.user.lastname}`,
        street: this.locations.userLocation.street,
        houseNumber: this.locations.userLocation.houseNumber.toString(),
        postcode: this.locations.userLocation.postcode.toString(),
        city: this.locations.userLocation.city,
        email: this.user.email,
        reason: this.reasons.selectedReasonIndex.toString(),
        telephone: this.user.telephone,
        weekday: this.locations.userLocation.schedule[0],
        reasonMessage: this.reasons.otherReason
      };
       axios.post(`${window.app.pnpform.api_base}soap`, data).then(() => {
         this.view.viewName = 'Success'
       }).catch((error) => {
         console.log(error);
       });
    },
  },
  setup() {
    const user = useUserStore();
    const locations = useLocationStore();
    const reasons = useReasonStore();
    const deliveries = useDeliveryStore();
    const view = useViewStore();
    function updateView(name) {
      view.viewName = name;
      view.counter += 1;
    }
    return {
      user,
      locations,
      deliveries,
      reasons,
      view,
      updateView,
    };
  },
};
</script>
